import { DAY, HOUR, spanOf, type TimeWindow } from "./window";

/** A span the user can pick in one click. */
export interface SpanPreset {
  value: string;
  label: string;
  span: number;
}

/** The spans the toolbar offers, shortest first. */
export const SPAN_PRESETS: readonly SpanPreset[] = [
  { value: "1h", label: "1h", span: HOUR },
  { value: "1d", label: "1d", span: DAY },
  { value: "1w", label: "1w", span: 7 * DAY },
  { value: "30d", label: "30d", span: 30 * DAY },
];

/**
 * The preset `window` shows: the one whose span it has exactly, else `null`
 * — after a free zoom nothing is pressed.
 */
export function activePreset(window: TimeWindow): string | null {
  const span = spanOf(window);
  return SPAN_PRESETS.find((preset) => preset.span === span)?.value ?? null;
}

/**
 * The window a preset of `span` milliseconds gives from `window`: it keeps
 * the right edge and sets the span, so after a pan the user is reading the
 * same end of the history at a new scale. Before clamping.
 */
export function presetWindow(window: TimeWindow, span: number): TimeWindow {
  return { start: window.end - span, end: window.end };
}
